/**
 * 표시 전용 포맷 헬퍼. 금액은 **문자열 그대로** 다룬다 — parseFloat 로 왕복시키면
 * 소수 4자리가 깎인다(businweb 이관·정산에서 반복해 데인 함정).
 */

/** "1350000.0000" → "1,350,000". 소수부가 0이 아니면 유지. 음수·빈값 안전. */
export function won(v: string | number | null | undefined): string {
  if (v === null || v === undefined || v === '') return '0';
  const s = String(v).trim();
  const neg = s.startsWith('-');
  const body = neg ? s.slice(1) : s;
  const parts = body.split('.');
  const intPart = parts[0] ?? '0';
  const dec = (parts[1] ?? '').replace(/0+$/, '');
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `${neg ? '-' : ''}${withCommas}${dec ? '.' + dec : ''}`;
}

/** 숫자열 → 010-0000-0000. */
export function phone(digits: string): string {
  const d = (digits ?? '').replace(/[^0-9]/g, '').slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
}

/** "YYYY-MM-DD HH:mm" 벽시계 문자열을 사람 읽기 좋게. 형태가 다르면 원문 그대로. */
export function when(s: string | null | undefined): string {
  if (!s) return '-';
  const m = /^(\d{4})-(\d{2})-(\d{2})[ T]?(\d{2}:\d{2})?/.exec(s.trim());
  if (!m) return s;
  const [, , mo, d, hm] = m;
  return `${Number(mo)}월 ${Number(d)}일${hm ? ` ${hm}` : ''}`;
}

/** 도착 일시 — 시간 없이 넣은 값(23:59 저장)은 날짜만(담당자 화면 arrivalClock 과 같은 규칙). */
export function whenArrive(s: string | null | undefined): string {
  if (s && /[ T]23:59/.test(s)) return when(s.trim().slice(0, 10));
  return when(s);
}

/** "YYYY-MM" → "YYYY년 M월". */
export function monthLabel(mon: string): string {
  const m = /^(\d{4})-(\d{2})$/.exec(mon);
  return m ? `${m[1]}년 ${Number(m[2])}월` : mon;
}

/**
 * 공개 예약 시각(KST 벽시계 `YYYY-MM-DDTHH:MM:SS`) → "9월 25일 18:00".
 * 값이 없으면 `null` — 화면이 "시각 미정"과 "언제부터"를 갈라 쓸 수 있게 문자열을 만들지 않는다.
 */
export function openAtLabel(s: string | null | undefined): string | null {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/.exec(String(s).trim());
  if (!m) return String(s);
  return `${Number(m[2])}월 ${Number(m[3])}일 ${m[4]}:${m[5]}`;
}
